<script>
export default {
    mixins: [Fieldtype],
    render() {
        return '';
    }
};
</script>
